import cx from 'classnames';
import { IndentDecrease, IndentIncrease, Filter } from 'tabler-icons-react';
import { useSelector, useDispatch } from 'react-redux';
import { useModal } from 'Hooks';
import { setSidebar, setSelectedMarker } from 'Actions';
import { SearchBox, Button, ModalBoxFilter } from 'Elements';
import styles from 'partials/mobile-searchbar.module.scss';

export const MobileSearchBar = ({ isOpenSide }) => {
	const sidebar = useSelector((state) => state.sidebar);
	const stories = useSelector((state) => state.marker);
	const dispatch = useDispatch();
	const [openModal, toggleModal] = useModal();

	const handleSidebar = () => {
		dispatch(setSidebar(!sidebar.isOpen));
		dispatch(setSelectedMarker({}));
	};

	const handleSubmit = (val) => {
		dispatch(setSidebar(open));
		dispatch(setSelectedMarker(val));
	};

	return (
		<div className={styles.box}>
			<Button
				className={cx(styles.trigger, styles.side)}
				onClick={handleSidebar}>
				{!isOpenSide && <IndentDecrease size={27} />}
				{isOpenSide && <IndentIncrease size={27} color="#ebc365" />}
			</Button>
			<SearchBox className={styles.search} onSubmit={handleSubmit} />
			<Button
				className={cx(styles.trigger, styles.filter)}
				onClick={toggleModal}>
				<Filter size={27} />
			</Button>
			<ModalBoxFilter
				isOpen={openModal}
				onClose={toggleModal}
				size="sm"
				stories={stories}
			/>
		</div>
	);
};
